export enum StudentStudyNavPage {
    SELF_STUDY_PROGRESS = 'SELF_STUDY_PROGRESS',
    TOPIC_PERFORMANCE = 'TOPIC_PERFORMANCE'
}

export const Emdash = '—';
export const MiniEmdash = '–';

export const LeydenIcons = {
  STANDARD: {
    name: 'Standard',
    id: 'els-hmds-icon-standard'
  },
  IDEA: {
    name: 'Idea',
    id: 'els-gizmo-icon-idea'
  },
  MEDAL: {
    name: 'Medal',
    idGizmo: 'els-gizmo-icon-medal',
    idHMDS: 'els-hmds-icon-medal'
  }
};
